import { Translatable } from '@icc/shared/helpers';

/** Typ produktu */
export class PleatedMosquitoScreenType {
    id: number;
    /** Nazwa */
    @Translatable({ model: 'ShutterTypes' })
    name: string;
    /** Nazwa systemowa */
    nameCms?: string;
    /** Kod do wydruków */
    printCode?: string;
    /** Wariant moskitiery plisowanej */
    variant?: 'single' | 'double';
    /** Opis */
    description: string;
    /** Zdjęcie */
    img: string;
    /** Ma przypisane rodzaje montażu */
    hasMontageTypes: boolean;
    /** Kolejność */
    order?: number;
    /** Id zakresu rozmiarów */
    sizeRangeId?: number;
}
